const siteSections = [
  {
    group: "marketMonitor",
    section: "Market Monitor",
    tabPaths: ["/market-monitor/sourcing-model", "/market-monitor/universe-explorer", "/market-monitor/research"],
    homeEntryLabel: "Sourcing Model",
    homeDescription: "Launch sourcing, universe exploration, and research workflows.",
    homeAccent: "#135d66",
  },
  {
    group: "activityMonitor",
    section: "Activity Monitor",
    tabPaths: [
      "/activity-monitor/pipeline",
      "/activity-monitor/crm",
      "/activity-monitor/tasks",
      "/activity-monitor/tenant_tasks",
    ],
    homeEntryLabel: "Pipeline",
    homeDescription: "Jump into pipeline, CRM, and task management views.",
    homeAccent: "#8a4fff",
  },
  {
    group: "creditMonitor",
    section: "Credit Monitor",
    sectionEntryPath: "/credit-monitor/dashboard",
    tabPaths: [
      "/credit-monitor/workbench",
      "/credit-monitor/dashboard",
      "/credit-monitor/detail",
      "/credit-monitor/research",
    ],
    homeEntryLabel: "Dashboard",
    homeDescription: "Open the legacy credit dashboard, detail, and research tools.",
    homeAccent: "#0f3d91",
  },
  {
    group: "portfolioData",
    section: "Portfolio Data",
    tabPaths: [
      "/portfolio/dashboard",
      "/portfolio/property",
      "/portfolio/purchase",
      "/portfolio/sale",
      "/portfolio/funding",
      "/portfolio/lease",
      "/portfolio/due-diligence",
      "/portfolio/disposition-model",
    ],
    homeEntryLabel: "Dashboard",
    homeDescription: "Go straight to portfolio dashboards and underlying property views.",
    homeAccent: "#bc6c25",
  },
];

export default siteSections;
